__turbopack_context__.v({
  "accordionSlideOverwrite": "featureListScroll-module-scss-module__ImAnFW__accordionSlideOverwrite",
  "cardActive": "featureListScroll-module-scss-module__ImAnFW__cardActive",
  "cardImage": "featureListScroll-module-scss-module__ImAnFW__cardImage",
  "cardInactive": "featureListScroll-module-scss-module__ImAnFW__cardInactive",
  "cardWrap": "featureListScroll-module-scss-module__ImAnFW__cardWrap",
  "cardsRail": "featureListScroll-module-scss-module__ImAnFW__cardsRail",
  "desktopLayout": "featureListScroll-module-scss-module__ImAnFW__desktopLayout",
  "fadeIn": "featureListScroll-module-scss-module__ImAnFW__fadeIn",
  "fadeOut": "featureListScroll-module-scss-module__ImAnFW__fadeOut",
  "featureBody": "featureListScroll-module-scss-module__ImAnFW__featureBody",
  "featureContent": "featureListScroll-module-scss-module__ImAnFW__featureContent",
  "featureContentLayer": "featureListScroll-module-scss-module__ImAnFW__featureContentLayer",
  "featureItem": "featureListScroll-module-scss-module__ImAnFW__featureItem",
  "featureItemActive": "featureListScroll-module-scss-module__ImAnFW__featureItemActive",
  "featureItemNext": "featureListScroll-module-scss-module__ImAnFW__featureItemNext",
  "featureListScroll": "featureListScroll-module-scss-module__ImAnFW__featureListScroll",
  "featurePreview": "featureListScroll-module-scss-module__ImAnFW__featurePreview",
  "featureStack": "featureListScroll-module-scss-module__ImAnFW__featureStack",
  "featureTitle": "featureListScroll-module-scss-module__ImAnFW__featureTitle",
  "leftColumn": "featureListScroll-module-scss-module__ImAnFW__leftColumn",
  "list": "featureListScroll-module-scss-module__ImAnFW__list",
  "listCopy": "featureListScroll-module-scss-module__ImAnFW__listCopy",
  "listIcon": "featureListScroll-module-scss-module__ImAnFW__listIcon",
  "listItem": "featureListScroll-module-scss-module__ImAnFW__listItem",
  "mobileContent": "featureListScroll-module-scss-module__ImAnFW__mobileContent",
  "mobileImageWrap": "featureListScroll-module-scss-module__ImAnFW__mobileImageWrap",
  "mobileItem": "featureListScroll-module-scss-module__ImAnFW__mobileItem",
  "mobileStack": "featureListScroll-module-scss-module__ImAnFW__mobileStack",
  "previewHeadingSlot": "featureListScroll-module-scss-module__ImAnFW__previewHeadingSlot",
  "rightColumn": "featureListScroll-module-scss-module__ImAnFW__rightColumn",
  "scaleIn": "featureListScroll-module-scss-module__ImAnFW__scaleIn",
  "scaleOut": "featureListScroll-module-scss-module__ImAnFW__scaleOut",
  "summary": "featureListScroll-module-scss-module__ImAnFW__summary",
  "zoomIn": "featureListScroll-module-scss-module__ImAnFW__zoomIn",
  "zoomOut": "featureListScroll-module-scss-module__ImAnFW__zoomOut",
});
